// Libraries
import { Box, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";

// Custom
import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { ResetStyle } from "./ResetStyle";
import ResetViewModel from "Custom/ViewModels/ProductSelector/SubViewModels/ResetViewModel";
import { BQSButton } from "Custom/Views/Primitives/Buttons/BQSButton";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";

interface IProps {
    className?: string;
}

export const Reset: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const [viewModel] = useState(() => new ResetViewModel());

    const editVariants = EditVariants();
    const typopgraphyVariants = TypographyVariants();
    const emailStyle = ResetStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={emailStyle.root}>
            <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                Reset this quote and return to the enter customer details page
            </Typography>
            <BQSRow>
                {viewModel.showResetButton === true && (
                    <BQSButton canExecute={true} className={emailStyle.bqsResetButton} displayName="Reset Quote & User" execute={viewModel.reset} />
                )}
            </BQSRow>
        </Box>
    ));

    // #endregion Render Result
};
